import { render } from "./packets.vue?vue&type=template&id=87598e66"
import script from "./packets.vue?vue&type=script&lang=js"
export * from "./packets.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__